module.exports = __webpack_public_path__ + "img/search-icon.174272f3.svg";